import { render, staticRenderFns } from "./OrderPlaceComment.vue?vue&type=template&id=5043a80b&scoped=true&"
import script from "./OrderPlaceComment.vue?vue&type=script&lang=js&"
export * from "./OrderPlaceComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5043a80b",
  null
  
)

export default component.exports